import { render, staticRenderFns } from "./share_polite.vue?vue&type=template&id=173a9a65&scoped=true"
import script from "./share_polite.vue?vue&type=script&lang=js"
export * from "./share_polite.vue?vue&type=script&lang=js"
import style0 from "./share_polite.vue?vue&type=style&index=0&id=173a9a65&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "173a9a65",
  null
  
)

export default component.exports